import { Injectable, inject } from '@angular/core';
import { MarketDataSpreadingRule } from '@approot/models';
import { StrategyDetailService } from '../strategy-detail/strategy-detail.service';
export const MARKET_DATA_LIVE = 'LIVE';
export const MARKET_DATA_AUTO_REFRESH = 'AUTO_REFRESH';
export const MARKET_DATA_PAST_DATE = 'PAST_DATE';

export type marketDataDateType =
  | typeof MARKET_DATA_LIVE
  | typeof MARKET_DATA_AUTO_REFRESH
  | typeof MARKET_DATA_PAST_DATE;

@Injectable({
  providedIn: 'root'
})
export class PricingExtraService {
  private _currencies: string[] = []; // all different currencies from the currency Pair
  private _marketDataSpreadingRule: MarketDataSpreadingRule;
  private strategyDetailService = inject(StrategyDetailService);

  constructor() {}

  set setCurrencies(currencies: string[]) {
    this._currencies = currencies;
  }

  get currencies(): string[] {
    return this._currencies;
  }

  set setMarketDataSpreadingRule(rules: MarketDataSpreadingRule) {
    this._marketDataSpreadingRule = rules;
  }

  get marketDataSpreadingRule(): MarketDataSpreadingRule {
    return this._marketDataSpreadingRule;
  }

  get getMarketDataTimeStamp(): string {
    // return the frozen time if we are not using live market data
    return this.strategyDetailService.marketDataToUse === MARKET_DATA_PAST_DATE
      ? this.strategyDetailService.currentTab.marketData.frozenTime
      : '';
  }
}
